import React, { useState } from 'react';
import { CalendarIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, ReceiptIcon } from 'lucide-react';
const LawajamHistoryScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'all' | 'paid' | 'pending'>('all');
  const lawajamHistory = [{
    id: 1,
    amount: '₹500',
    date: 'June 10, 2023',
    time: '10:30 AM',
    reference: 'LWJ-2023-001',
    status: 'paid',
    period: 'June 2023'
  }, {
    id: 2,
    amount: '₹500',
    date: 'May 15, 2023',
    time: '11:45 AM',
    reference: 'LWJ-2023-002',
    status: 'paid',
    period: 'May 2023'
  }, {
    id: 3,
    amount: '₹500',
    date: 'April 12, 2023',
    time: '9:15 AM',
    reference: 'LWJ-2023-003',
    status: 'paid',
    period: 'April 2023'
  }, {
    id: 4,
    amount: '₹500',
    date: 'July 1, 2023',
    time: '',
    reference: 'LWJ-2023-004',
    status: 'pending',
    period: 'July 2023'
  }];
  const filteredHistory = activeTab === 'all' ? lawajamHistory : lawajamHistory.filter(item => item.status === activeTab);
  return <div className="px-4 py-6" data-id="element-101">
      <div className="mb-6" data-id="element-102">
        <h1 className="text-xl font-bold text-gray-900" data-id="element-103">Lawajam History</h1>
        <p className="text-gray-600 text-sm" data-id="element-104">
          Track your lawajam contributions
        </p>
      </div>
      {/* Summary Card */}
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-105">
        <h2 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-106">Summary</h2>
        <div className="grid grid-cols-2 gap-4" data-id="element-107">
          <div className="bg-blue-50 rounded-lg p-3" data-id="element-108">
            <p className="text-sm text-gray-600" data-id="element-109">Total Paid</p>
            <p className="text-xl font-bold text-gray-900" data-id="element-110">₹1,500</p>
          </div>
          <div className="bg-red-50 rounded-lg p-3" data-id="element-111">
            <p className="text-sm text-gray-600" data-id="element-112">Pending</p>
            <p className="text-xl font-bold text-red-600" data-id="element-113">₹500</p>
          </div>
        </div>
      </div>
      {/* Tab Navigation */}
      <div className="flex mb-6 border-b border-gray-200" data-id="element-114">
        <button className={`flex-1 py-3 text-center font-medium ${activeTab === 'all' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab('all')} data-id="element-115">
          All
        </button>
        <button className={`flex-1 py-3 text-center font-medium ${activeTab === 'paid' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab('paid')} data-id="element-116">
          Paid
        </button>
        <button className={`flex-1 py-3 text-center font-medium ${activeTab === 'pending' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab('pending')} data-id="element-117">
          Pending
        </button>
      </div>
      {/* Lawajam Transactions */}
      <div className="space-y-4" data-id="element-118">
        {filteredHistory.length > 0 ? filteredHistory.map(item => <div key={item.id} className="bg-white rounded-lg shadow-sm p-4" data-id="element-119">
              <div className="flex justify-between items-start mb-2" data-id="element-120">
                <div data-id="element-121">
                  <h3 className="font-semibold text-gray-900" data-id="element-122">{item.amount}</h3>
                  <p className="text-sm text-gray-600" data-id="element-123">For {item.period}</p>
                </div>
                {item.status === 'paid' ? <div className="px-3 py-1 bg-green-100 text-green-800 text-xs rounded-full flex items-center" data-id="element-124">
                    <CheckCircleIcon className="w-3 h-3 mr-1" data-id="element-125" />
                    Paid
                  </div> : <div className="px-3 py-1 bg-red-100 text-red-800 text-xs rounded-full flex items-center" data-id="element-126">
                    <ClockIcon className="w-3 h-3 mr-1" data-id="element-127" />
                    Pending
                  </div>}
              </div>
              <div className="flex items-center text-sm text-gray-700 mb-1" data-id="element-128">
                <CalendarIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-129" />
                <span data-id="element-130">{item.date}</span>
              </div>
              {item.time && <div className="flex items-center text-sm text-gray-700 mb-1" data-id="element-131">
                  <ClockIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-132" />
                  <span data-id="element-133">{item.time}</span>
                </div>}
              <div className="flex items-center text-sm text-gray-700" data-id="element-134">
                <ReceiptIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-135" />
                <span data-id="element-136">Reference: {item.reference}</span>
              </div>
              {item.status === 'pending' && <button className="mt-3 w-full py-2 bg-blue-600 text-white rounded-md text-sm font-medium" data-id="element-137">
                  Pay Now
                </button>}
              {item.status === 'paid' && <button className="mt-3 w-full py-2 bg-gray-100 text-gray-700 rounded-md text-sm font-medium flex justify-center items-center" data-id="element-138">
                  <ReceiptIcon className="w-4 h-4 mr-2" data-id="element-139" />
                  View Receipt
                </button>}
            </div>) : <div className="bg-gray-50 rounded-lg p-8 text-center" data-id="element-140">
            <AlertCircleIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" data-id="element-141" />
            <h3 className="text-gray-700 font-medium mb-1" data-id="element-142">
              No Transactions Found
            </h3>
            <p className="text-gray-500 text-sm" data-id="element-143">
              No {activeTab === 'all' ? '' : activeTab} lawajam records
              available.
            </p>
          </div>}
      </div>
    </div>;
};
export default LawajamHistoryScreen;